import { Segment } from "./Segment";

export class Route {
  designation:string;
  segments : Segment[] = [];
  status : boolean = true;
  continuous : boolean = true;
  isSelected : boolean = false;
}
